export var BORDER_RADIUS = '24px';
export var PADDING = '24px';
//# sourceMappingURL=constants.js.map